export default __webpack_public_path__ + "static/media/chevron-down.371c0b7e.svg";